export enum SchematicVersionStatus {
    Draft = 'Draft',
    Released = 'Released',
    Obsolete = 'Obsolete',
}
